import { createApp } from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import * as Components from './'
import dasherize from '../helpers/dasherize'

const mount = () => {
  for (let name in Components) {
    const Component = Components[name]
    const componentName = dasherize(Component.name)
    const elements = document.querySelectorAll(`[data-vue="${componentName}"`)

    if (elements) {
      elements.forEach(element => {
        const app = createApp({
          mixins: [TurbolinksAdapter],
          components: { [Component.name]: Component }
        })

        app.mount(element)
      })
    }
  }
}

document.addEventListener('turbolinks:load', mount)
